module.exports = __webpack_public_path__ + "img/Introduction_to_Software_Engineering_Management.bd62700c.jpeg";